/**
 * Canonical portal emoji set — the single source of truth for the emojis used
 * to represent portal sections and departments/pillars.
 *
 * These mirror the PortalSidebar navigation so the sidebar, the client
 * dashboard, and every department hub (Community · Roadmap · Goals cards, etc.)
 * all render the same glyph for the same concept. When the sidebar changes, this
 * map is the only place that needs to move with it.
 */
export const PORTAL_EMOJI = {
  // Nav sections
  dashboard: '🏠',
  roadmap: '🗺️',
  hours: '⏱️',
  courses: '🎓',
  tasks: '✅',
  messages: '✉️',
  questions: '❓',
  calendar: '📅',
  community: '💬',
  conference: '🎥',
  collection: '🗂️',
  goals: '🎯',
  jobtread: '🏗️',

  // Departments / pillars
  sales: '🚀',
  operations: '⚙️',
  technology: '🤖',
  finance: '💵',
  marketing: '📣',
  hr: '👥',

  // Roadmap-only phases / fallbacks
  onboarding: '🚀',
  general: '📋',
};

/**
 * Emoji for a department/pillar/section id (case-insensitive).
 * Falls back to the neutral 📋 when the id isn't a known concept.
 * @param {string} id - e.g. "sales", "Operations", "roadmap"
 */
export const getPortalEmoji = (id) =>
  PORTAL_EMOJI[String(id || '').toLowerCase()] || PORTAL_EMOJI.general;

/** Back-compat alias — department/pillar lookups read more naturally as "pillar". */
export const getPillarEmoji = getPortalEmoji;
